export const PDF = "pdf";
export const IMAGE = "png";
export const BACKGROUNDIMAGE = "jpg";



// WEBPACK FOOTER //
// ./src/constants/modelExportTypes.js